import { __decorate, __metadata } from 'tslib';
import { ChangeDetectorRef, HostBinding, Input, ViewChild, ElementRef, Component, forwardRef, EventEmitter, Output, ContentChildren, QueryList, HostListener, ViewEncapsulation, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MdlPopoverComponent, MdlPopoverModule } from '@angular-mdl/popover';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular-mdl/popover';

const _c0 = ["contentWrapper"];
function MdlOptionComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelement(2, "input", 6);
    ɵngcc0.ɵɵelement(3, "span", 7);
    ɵngcc0.ɵɵelement(4, "span", 8);
    ɵngcc0.ɵɵelementStart(5, "span", 9);
    ɵngcc0.ɵɵelement(6, "span", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("is-checked", ctx_r0.selected);
} }
const _c1 = ["*"];
const _c2 = ["selectInput"];
function MdlSelectComponent_ng_content_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 0, ["*ngIf", "popoverComponent.isVisible"]);
} }
let MdlOptionComponent = class MdlOptionComponent {
    constructor(changeDetectionRef) {
        this.changeDetectionRef = changeDetectionRef;
        // tslint:disable-next-line
        this.disabled = false;
        this.isOptionConatiner = true;
        this.multiple = false;
        this.selected = false;
        this.onSelect = Function.prototype;
    }
    get stringValue() {
        return this.stringifyValue(this.value);
    }
    select(event) {
        if (this.disabled) {
            event.stopPropagation();
            event.preventDefault();
        }
        else {
            this.onSelect(this.value);
        }
    }
    setMultiple(multiple) {
        this.multiple = multiple;
        this.changeDetectionRef.detectChanges();
    }
    updateSelected(value) {
        if (this.multiple) {
            this.selected = ((value || []).map((v) => this.stringifyValue(v)).indexOf(this.stringValue) !== -1);
        }
        else {
            this.selected = this.value === value;
        }
        if (!this.changeDetectionRef.destroyed) {
            this.changeDetectionRef.detectChanges();
        }
    }
    ngAfterViewInit() {
        this.text = this.contentWrapper.nativeElement.textContent.trim();
    }
    stringifyValue(value) {
        switch (typeof value) {
            case 'number':
                return String(value);
            case 'object':
                return JSON.stringify(value);
            default:
                return (!!value) ? String(value) : '';
        }
    }
};
MdlOptionComponent.ɵfac = function MdlOptionComponent_Factory(t) { return new (t || MdlOptionComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
MdlOptionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MdlOptionComponent, selectors: [["mdl-option"]], viewQuery: function MdlOptionComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentWrapper = _t.first);
    } }, hostVars: 4, hostBindings: function MdlOptionComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdl-option--disabled", ctx.disabled)("mdl-option__container", ctx.isOptionConatiner);
    } }, inputs: { disabled: "disabled", value: "value" }, ngContentSelectors: _c1, decls: 5, vars: 3, consts: [[1, "mdl-list__item", 3, "click"], ["class", "mdl-list__item-secondary-action", 4, "ngIf"], [1, "mdl-list__item-primary-content"], ["contentWrapper", ""], [1, "mdl-list__item-secondary-action"], [1, "mdl-checkbox", "is-upgraded"], ["type", "checkbox", 1, "mdl-checkbox__input"], [1, "mdl-checkbox__label"], [1, "mdl-checkbox__focus-helper"], [1, "mdl-checkbox__box-outline"], [1, "mdl-checkbox__tick-outline"]], template: function MdlOptionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function MdlOptionComponent_Template_div_click_0_listener($event) { return ctx.select($event); });
        ɵngcc0.ɵɵtemplate(1, MdlOptionComponent_div_1_Template, 7, 2, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2, 3);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("is-active", ctx.selected);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.multiple);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2 });
MdlOptionComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
__decorate([
    HostBinding('class.mdl-option--disabled'),
    Input('disabled'),
    __metadata("design:type", Object)
], MdlOptionComponent.prototype, "disabled", void 0);
__decorate([
    Input('value'),
    __metadata("design:type", Object)
], MdlOptionComponent.prototype, "value", void 0);
__decorate([
    ViewChild('contentWrapper', { static: true }),
    __metadata("design:type", ElementRef)
], MdlOptionComponent.prototype, "contentWrapper", void 0);
__decorate([
    HostBinding('class.mdl-option__container'),
    __metadata("design:type", Object)
], MdlOptionComponent.prototype, "isOptionConatiner", void 0);
MdlOptionComponent = __decorate([ __metadata("design:paramtypes", [ChangeDetectorRef])
], MdlOptionComponent);

var Key;
(function (Key) {
    Key[Key["Tab"] = 9] = "Tab";
    Key[Key["Enter"] = 13] = "Enter";
    Key[Key["Escape"] = 27] = "Escape";
    Key[Key["UpArrow"] = 38] = "UpArrow";
    Key[Key["DownArrow"] = 40] = "DownArrow";
    Key[Key["A"] = 65] = "A";
    Key[Key["B"] = 66] = "B";
    Key[Key["C"] = 67] = "C";
    Key[Key["D"] = 68] = "D";
    Key[Key["E"] = 69] = "E";
    Key[Key["F"] = 70] = "F";
    Key[Key["G"] = 71] = "G";
    Key[Key["H"] = 72] = "H";
    Key[Key["I"] = 73] = "I";
    Key[Key["J"] = 74] = "J";
    Key[Key["K"] = 75] = "K";
    Key[Key["L"] = 76] = "L";
    Key[Key["M"] = 77] = "M";
    Key[Key["N"] = 78] = "N";
    Key[Key["O"] = 79] = "O";
    Key[Key["P"] = 80] = "P";
    Key[Key["Q"] = 81] = "Q";
    Key[Key["R"] = 82] = "R";
    Key[Key["S"] = 83] = "S";
    Key[Key["T"] = 84] = "T";
    Key[Key["U"] = 85] = "U";
    Key[Key["V"] = 86] = "V";
    Key[Key["W"] = 87] = "W";
    Key[Key["X"] = 88] = "X";
    Key[Key["Y"] = 89] = "Y";
    Key[Key["Z"] = 90] = "Z";
})(Key || (Key = {}));
function keyboardEventKeyCode($event) {
    // tslint:disable-next-line
    return ($event.which || $event.charCode || $event.keyCode);
}
function keyboardEventKey($event) {
    return $event.key || String.fromCharCode(keyboardEventKeyCode($event));
}
function isKey($event, ...keys) {
    return keys.indexOf(keyboardEventKeyCode($event)) !== -1;
}
function isCharacterKey($event) {
    const keyCode = keyboardEventKeyCode($event);
    return !!String.fromCharCode(keyCode) && keyCode >= 48 && keyCode <= 90;
}

const uniq = (array) => Array.from(new Set(array));
const ɵ0 = uniq;
const isEqual = (a, b) => JSON.stringify(a) === JSON.stringify(b);
const ɵ1 = isEqual;
function toBoolean(value) {
    return value != null && `${value}` !== 'false';
}
function randomId() {
    // tslint:disable-next-line
    const S4 = () => (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    return (S4() + S4());
}
const MDL_SELECT_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line
    useExisting: forwardRef(() => MdlSelectComponent),
    multi: true
};
class SearchableComponent {
    constructor() {
        this.searchQuery = '';
        this.clearTimeout = null;
    }
    // short search query will be cleared after 300 ms
    updateShortSearchQuery($event) {
        if (this.clearTimeout) {
            clearTimeout(this.clearTimeout);
        }
        this.clearTimeout = setTimeout(() => {
            this.searchQuery = '';
        }, 300);
        this.searchQuery += keyboardEventKey($event).toLowerCase();
    }
}
let MdlSelectComponent = class MdlSelectComponent extends SearchableComponent {
    constructor(changeDetectionRef, elementRef) {
        super();
        this.changeDetectionRef = changeDetectionRef;
        this.elementRef = elementRef;
        this.disabled = false;
        this.autocomplete = false;
        this.label = '';
        this.placeholder = '';
        this.multiple = false;
        // tslint:disable-next-line
        this.change = new EventEmitter(true);
        // tslint:disable-next-line
        this.blur = new EventEmitter(true);
        this.inputChange = new EventEmitter(true);
        this.isMdlSelect = true;
        this.directionUp = false;
        this.text = '';
        this.focused = false;
        this.textByValue = {};
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
        this.misFloatingLabel = false;
        this.textfieldId = `mdl-textfield-${randomId()}`;
    }
    get isPlaceholder() {
        return !!this.placeholder;
    }
    get isFloatingLabel() {
        return this.misFloatingLabel;
    }
    set isFloatingLabel(value) {
        this.misFloatingLabel = toBoolean(value);
    }
    ngAfterContentInit() {
        this.bindOptions();
        this.renderValue(this.ngModel);
        this.optionComponents.changes.subscribe(() => {
            this.bindOptions();
            this.renderValue(this.ngModel);
        });
        this.popoverComponent.onShow.subscribe(() => this.onOpen());
        this.popoverComponent.onHide.subscribe(() => this.onClose());
    }
    ngAfterViewInit() {
        this.selectElement = this.elementRef.nativeElement;
        this.popoverElement = this.popoverComponent.elementRef.nativeElement;
    }
    isDirty() {
        return Boolean(this.selectInput.nativeElement.value);
    }
    // rebind options and reset value in connected select
    reset(resetValue = true) {
        if (resetValue && !this.isEmpty()) {
            this.ngModel = this.multiple ? [] : '';
            this.onChange(this.ngModel);
            this.change.emit(this.ngModel);
            this.renderValue(this.ngModel);
        }
    }
    toggle($event) {
        if (!this.disabled) {
            $event.stopPropagation();
            this.popoverComponent.toggle($event);
        }
    }
    onFocus($event) {
        if (!this.popoverComponent.isVisible) {
            setTimeout(() => {
                this.popoverComponent.show($event);
                this.selectInput.nativeElement.focus();
            }, 200);
        }
    }
    onInputFocus($event) {
        if (this.autocomplete) {
            this.selectInput.nativeElement.select();
        }
    }
    writeValue(value) {
        if (this.multiple) {
            this.ngModel = this.ngModel || [];
            if (!value || this.ngModel === value) {
                // skip ngModel update when undefined value or multiple selects initialized with same array
            }
            else if (Array.isArray(value)) {
                this.ngModel = uniq(this.ngModel.concat(value));
            }
            else if (this.ngModel.map((v) => this.stringifyValue(v)).indexOf(this.stringifyValue(value)) !== -1) {
                this.ngModel = [...this.ngModel.filter((v) => this.stringifyValue(v) !== this.stringifyValue(value))];
            }
            else if (!!value) {
                this.ngModel = [...this.ngModel, value];
            }
        }
        else {
            this.ngModel = value;
        }
        this.onChange(this.ngModel);
        this.renderValue(this.ngModel);
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    onKeyDown($event) {
        if (!this.disabled && this.popoverComponent.isVisible && !this.multiple) {
            if (isKey($event, Key.UpArrow)) {
                this.onArrow($event, -1);
            }
            else if (isKey($event, Key.DownArrow)) {
                this.onArrow($event, 1);
            }
            else if (!this.autocomplete && isCharacterKey($event)) {
                this.onCharacterKeydown($event);
            }
        }
    }
    onKeyUp($event) {
        const inputField = $event.target;
        const inputValue = inputField.value;
        if (!this.multiple && isKey($event, Key.Enter, Key.Escape, Key.Tab)) {
            this.searchQuery = '';
            if (isKey($event, Key.Enter)) {
                this.setCurrentOptionValue();
            }
            else {
                inputField.value = this.text;
            }
            inputField.blur();
            this.popoverComponent.hide();
        }
        else if (this.autocomplete && !isKey($event, Key.DownArrow, Key.UpArrow)) {
            this.inputChange.emit(inputValue);
            this.searchQuery = inputValue;
        }
        $event.preventDefault();
    }
    setCurrentOptionValue() {
        const currentOption = this.getCurrentOption();
        const autoSelectedValue = this.getAutoSelection();
        const value = autoSelectedValue || (currentOption ? currentOption.value : this.ngModel);
        this.resetText();
        if (!isEqual(this.ngModel, value)) {
            this.writeValue(value);
            this.change.emit(value);
        }
    }
    resetText() {
        this.text = this.selectInput.nativeElement.value;
        this.changeDetectionRef.detectChanges();
    }
    getCurrentOption() {
        return this.optionComponents ? this.optionComponents.find(option => option.selected) : null;
    }
    onCharacterKeydown($event) {
        this.updateShortSearchQuery($event);
        const autoSelectedValue = this.getAutoSelection();
        if (autoSelectedValue) {
            this.onSelect(autoSelectedValue);
        }
        $event.preventDefault();
    }
    getAutoSelection() {
        const filteredOptions = this.optionComponents
            .filter(({ disabled }) => !disabled)
            .filter(option => {
            return option.text.toLowerCase().startsWith(this.searchQuery);
        });
        const selectedOption = this.optionComponents.find(option => option.selected);
        if (filteredOptions.length > 0) {
            const selectedOptionInFiltered = filteredOptions.indexOf(selectedOption) !== -1;
            if (!selectedOptionInFiltered && !filteredOptions[0].selected) {
                return filteredOptions[0].value;
            }
        }
        return null;
    }
    onArrow($event, offset) {
        const arr = this.optionComponents.toArray().filter(({ disabled }) => !disabled);
        const selectedOption = arr.find(option => option.selected);
        const selectedOptionIndex = arr.indexOf(selectedOption);
        const optionForSelection = selectedOption !== null
            ? arr[selectedOptionIndex + offset]
            : arr[offset > 0 ? -1 : 0];
        if (optionForSelection) {
            const value = optionForSelection.value;
            this.selectValue(value);
        }
        $event.preventDefault();
    }
    selectValue(value) {
        this.scrollToValue(value);
        if (this.optionComponents) {
            this.optionComponents.forEach((selectOptionComponent) => {
                selectOptionComponent.updateSelected(value);
            });
        }
    }
    isEmpty() {
        return this.multiple ? !this.ngModel.length : !this.ngModel;
    }
    bindOptions() {
        this.optionComponents.forEach((selectOptionComponent) => {
            selectOptionComponent.setMultiple(this.multiple);
            selectOptionComponent.onSelect = this.onSelect.bind(this);
            if (selectOptionComponent.value != null) {
                this.textByValue[this.stringifyValue(selectOptionComponent.value)]
                    = selectOptionComponent.contentWrapper.nativeElement.textContent.trim();
            }
        });
    }
    renderValue(value) {
        if (this.multiple) {
            this.text = (value || []).map((valueItem) => this.textByValue[this.stringifyValue(valueItem)]).join(', ');
        }
        else {
            this.text = this.textByValue[this.stringifyValue(value)] || '';
        }
        this.changeDetectionRef.detectChanges();
        if (this.optionComponents) {
            const mvalue = (!this.multiple && this.optionComponents.length === 1)
                ? this.optionComponents.first.value
                : value;
            this.optionComponents.forEach((selectOptionComponent) => {
                selectOptionComponent.updateSelected(mvalue);
            });
        }
    }
    stringifyValue(value) {
        switch (typeof value) {
            case 'number':
                return String(value);
            case 'object':
                return JSON.stringify(value);
            default:
                return (!!value) ? String(value) : '';
        }
    }
    onOpen() {
        if (!this.disabled) {
            this.popoverElement.style.visibility = 'hidden';
            setTimeout(() => {
                this.focused = true;
                this.selectValue(this.ngModel);
                this.tryToUpdateDirection();
                this.popoverElement.style.visibility = 'visible';
            });
        }
    }
    tryToUpdateDirection() {
        const targetRect = this.selectElement.getBoundingClientRect();
        const viewHeight = window.innerHeight;
        const height = this.popoverElement.offsetHeight;
        if (height) {
            const bottomSpaceAvailable = viewHeight - targetRect.bottom;
            this.directionUp = bottomSpaceAvailable < height;
            this.changeDetectionRef.markForCheck();
        }
    }
    onClose() {
        if (!this.disabled) {
            this.focused = false;
            this.selectValue(this.ngModel);
            this.selectInput.nativeElement.value = this.text;
            this.popoverElement.style.visibility = 'hidden';
            this.blur.emit(this.ngModel);
        }
    }
    onSelect(value) {
        if (!this.multiple) {
            this.scrollToValue(value);
        }
        if (!isEqual(this.ngModel, value)) {
            this.writeValue(value);
            this.change.emit(value);
        }
    }
    scrollToValue(value) {
        const popover = this.popoverComponent.elementRef.nativeElement;
        const list = popover.querySelector('.mdl-list');
        const optionComponent = this.optionComponents.find(o => o.value === value);
        const optionElement = optionComponent
            ? optionComponent.contentWrapper.nativeElement
            : null;
        if (optionElement) {
            const selectedItemElem = optionElement.parentElement;
            const computedScrollTop = selectedItemElem.offsetTop - (list.clientHeight / 2) + (selectedItemElem.clientHeight / 2);
            list.scrollTop = Math.max(computedScrollTop, 0);
        }
    }
};
MdlSelectComponent.ɵfac = function MdlSelectComponent_Factory(t) { return new (t || MdlSelectComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdlSelectComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MdlSelectComponent, selectors: [["mdl-select"]], contentQueries: function MdlSelectComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdlOptionComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.optionComponents = _t);
    } }, viewQuery: function MdlSelectComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c2, 7);
        ɵngcc0.ɵɵviewQuery(MdlPopoverComponent, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.selectInput = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.popoverComponent = _t.first);
    } }, hostVars: 6, hostBindings: function MdlSelectComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function MdlSelectComponent_keydown_HostBindingHandler($event) { return ctx.onKeyDown($event); })("keyup", function MdlSelectComponent_keyup_HostBindingHandler($event) { return ctx.onKeyUp($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdl-select", ctx.isMdlSelect)("has-placeholder", ctx.isPlaceholder)("mdl-select--floating-label", ctx.isFloatingLabel);
    } }, inputs: { disabled: "disabled", autocomplete: "autocomplete", label: "label", placeholder: "placeholder", multiple: "multiple", isFloatingLabel: ["floating-label", "isFloatingLabel"], ngModel: "ngModel" }, outputs: { change: "change", blur: "blur", inputChange: "inputChange" }, features: [ɵngcc0.ɵɵProvidersFeature([MDL_SELECT_VALUE_ACCESSOR]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c1, decls: 13, vars: 21, consts: [[1, "mdl-textfield", "is-upgraded"], [3, "focus"], ["tabindex", "-1", 1, "mdl-textfield__input", 3, "placeholder", "readonly", "value", "change", "click", "focus"], ["selectInput", ""], [1, "mdl-select__toggle", "material-icons", 3, "click"], [1, "mdl-textfield__label"], [1, "mdl-textfield__error"], ["tabindex", "-1", 3, "hide-on-click"], ["popover", ""], [1, "mdl-list", "mdl-shadow--6dp"], [4, "ngIf"]], template: function MdlSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "span", 1);
        ɵngcc0.ɵɵlistener("focus", function MdlSelectComponent_Template_span_focus_1_listener($event) { return ctx.onFocus($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "input", 2, 3);
        ɵngcc0.ɵɵlistener("change", function MdlSelectComponent_Template_input_change_2_listener($event) { return $event.stopPropagation(); })("click", function MdlSelectComponent_Template_input_click_2_listener($event) { return ctx.toggle($event); })("focus", function MdlSelectComponent_Template_input_focus_2_listener($event) { return ctx.onInputFocus($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "span", 4);
        ɵngcc0.ɵɵlistener("click", function MdlSelectComponent_Template_span_click_4_listener($event) { return ctx.toggle($event); });
        ɵngcc0.ɵɵtext(5, " keyboard_arrow_down ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "label", 5);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(8, "span", 6);
        ɵngcc0.ɵɵelementStart(9, "mdl-popover", 7, 8);
        ɵngcc0.ɵɵelementStart(11, "div", 9);
        ɵngcc0.ɵɵtemplate(12, MdlSelectComponent_ng_content_12_Template, 1, 0, "ng-content", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("is-dirty", ctx.isDirty())("is-disabled", ctx.disabled)("is-focused", ctx.popoverComponent.isVisible || ctx.focused);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("tabindex", !ctx.disabled ? 0 : null);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("placeholder", ctx.placeholder ? ctx.placeholder : "")("readonly", ctx.disabled || !ctx.autocomplete)("value", ctx.text);
        ɵngcc0.ɵɵattribute("id", ctx.textfieldId);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵattribute("for", ctx.textfieldId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("min-width", 100, "%");
        ɵngcc0.ɵɵclassProp("direction-up", ctx.directionUp)("mdl-popover--above", ctx.autocomplete);
        ɵngcc0.ɵɵproperty("hide-on-click", !ctx.multiple);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.popoverComponent.isVisible);
    } }, directives: [ɵngcc2.MdlPopoverComponent, ɵngcc1.NgIf], encapsulation: 2 });
MdlSelectComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef }
];
__decorate([
    Input(),
    __metadata("design:type", Object)
], MdlSelectComponent.prototype, "ngModel", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], MdlSelectComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], MdlSelectComponent.prototype, "autocomplete", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], MdlSelectComponent.prototype, "label", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], MdlSelectComponent.prototype, "placeholder", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], MdlSelectComponent.prototype, "multiple", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], MdlSelectComponent.prototype, "change", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], MdlSelectComponent.prototype, "blur", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], MdlSelectComponent.prototype, "inputChange", void 0);
__decorate([
    ViewChild('selectInput', { static: true }),
    __metadata("design:type", ElementRef)
], MdlSelectComponent.prototype, "selectInput", void 0);
__decorate([
    ViewChild(MdlPopoverComponent, { static: true }),
    __metadata("design:type", MdlPopoverComponent)
], MdlSelectComponent.prototype, "popoverComponent", void 0);
__decorate([
    ContentChildren(MdlOptionComponent),
    __metadata("design:type", QueryList)
], MdlSelectComponent.prototype, "optionComponents", void 0);
__decorate([
    HostBinding('class.mdl-select'),
    __metadata("design:type", Object)
], MdlSelectComponent.prototype, "isMdlSelect", void 0);
__decorate([
    HostBinding('class.has-placeholder'),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], MdlSelectComponent.prototype, "isPlaceholder", null);
__decorate([
    HostBinding('class.mdl-select--floating-label'),
    Input('floating-label'),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], MdlSelectComponent.prototype, "isFloatingLabel", null);
__decorate([
    HostListener('keydown', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [KeyboardEvent]),
    __metadata("design:returntype", void 0)
], MdlSelectComponent.prototype, "onKeyDown", null);
__decorate([
    HostListener('keyup', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [KeyboardEvent]),
    __metadata("design:returntype", void 0)
], MdlSelectComponent.prototype, "onKeyUp", null);
MdlSelectComponent = __decorate([ __metadata("design:paramtypes", [ChangeDetectorRef,
        ElementRef])
], MdlSelectComponent);

var MdlSelectModule_1;
let MdlSelectModule = MdlSelectModule_1 = class MdlSelectModule {
    static forRoot() {
        return {
            ngModule: MdlSelectModule_1,
            providers: []
        };
    }
};
MdlSelectModule.ɵfac = function MdlSelectModule_Factory(t) { return new (t || MdlSelectModule)(); };
MdlSelectModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MdlSelectModule });
MdlSelectModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        MDL_SELECT_VALUE_ACCESSOR
    ], imports: [[
            CommonModule,
            MdlPopoverModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MdlOptionComponent, [{
        type: Component,
        args: [{
                selector: 'mdl-option',
                template: "<div\n    class=\"mdl-list__item\"\n    (click)=\"select($event)\"\n    [class.is-active]=\"selected\">\n\n  <div *ngIf=\"multiple\" class=\"mdl-list__item-secondary-action\">\n    <div class=\"mdl-checkbox is-upgraded\" [class.is-checked]=\"selected\">\n      <input type=\"checkbox\" class=\"mdl-checkbox__input\">\n      <span class=\"mdl-checkbox__label\"></span>\n      <span class=\"mdl-checkbox__focus-helper\"></span>\n      <span class=\"mdl-checkbox__box-outline\">\n        <span class=\"mdl-checkbox__tick-outline\"></span>\n      </span>\n    </div>\n  </div>\n\n  <div #contentWrapper class=\"mdl-list__item-primary-content\">\n    <ng-content></ng-content>\n  </div>\n\n</div>\n"
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { disabled: [{
            type: HostBinding,
            args: ['class.mdl-option--disabled']
        }, {
            type: Input,
            args: ['disabled']
        }], isOptionConatiner: [{
            type: HostBinding,
            args: ['class.mdl-option__container']
        }], value: [{
            type: Input,
            args: ['value']
        }], contentWrapper: [{
            type: ViewChild,
            args: ['contentWrapper', { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MdlSelectComponent, [{
        type: Component,
        args: [{
                selector: 'mdl-select',
                template: "<div\n  [class.is-dirty]=\"isDirty()\"\n  [class.is-disabled]=\"disabled\"\n  [class.is-focused]=\"popoverComponent.isVisible || focused\"\n  class=\"mdl-textfield is-upgraded\"\n>\n  <span\n    (focus)=\"onFocus($event);\"\n    [attr.tabindex]=\"!disabled ? 0 : null\">\n  </span>\n  <input #selectInput (change)=\"$event.stopPropagation()\"\n         (click)=\"toggle($event)\"\n         (focus)=\"onInputFocus($event);\"\n         [attr.id]=\"textfieldId\"\n         [placeholder]=\"placeholder ? placeholder : ''\"\n         [readonly]=\"disabled || !autocomplete\"\n         [value]=\"text\"\n         class=\"mdl-textfield__input\"\n         tabindex=\"-1\">\n  <span\n    (click)=\"toggle($event)\"\n    class=\"mdl-select__toggle material-icons\">\n    keyboard_arrow_down\n  </span>\n  <label [attr.for]=\"textfieldId\" class=\"mdl-textfield__label\">{{ label }}</label>\n  <span class=\"mdl-textfield__error\"></span>\n  <mdl-popover #popover [class.direction-up]=\"directionUp\"\n               [class.mdl-popover--above]=\"autocomplete\"\n               [hide-on-click]=\"!multiple\"\n               [style.minWidth.%]=\"100\"\n               tabindex=\"-1\">\n    <div class=\"mdl-list mdl-shadow--6dp\">\n      <ng-content *ngIf=\"popoverComponent.isVisible\"></ng-content>\n    </div>\n  </mdl-popover>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                providers: [MDL_SELECT_VALUE_ACCESSOR]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }]; }, { disabled: [{
            type: Input
        }], autocomplete: [{
            type: Input
        }], label: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], multiple: [{
            type: Input
        }], change: [{
            type: Output
        }], blur: [{
            type: Output
        }], inputChange: [{
            type: Output
        }], isMdlSelect: [{
            type: HostBinding,
            args: ['class.mdl-select']
        }], isPlaceholder: [{
            type: HostBinding,
            args: ['class.has-placeholder']
        }], isFloatingLabel: [{
            type: HostBinding,
            args: ['class.mdl-select--floating-label']
        }, {
            type: Input,
            args: ['floating-label']
        }], ngModel: [{
            type: Input
        }], onKeyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], onKeyUp: [{
            type: HostListener,
            args: ['keyup', ['$event']]
        }], selectInput: [{
            type: ViewChild,
            args: ['selectInput', { static: true }]
        }], popoverComponent: [{
            type: ViewChild,
            args: [MdlPopoverComponent, { static: true }]
        }], optionComponents: [{
            type: ContentChildren,
            args: [MdlOptionComponent]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MdlSelectModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MdlPopoverModule
                ],
                exports: [
                    MdlSelectComponent,
                    MdlOptionComponent
                ],
                declarations: [
                    MdlSelectComponent,
                    MdlOptionComponent
                ],
                providers: [
                    MDL_SELECT_VALUE_ACCESSOR
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MdlSelectModule, { declarations: function () { return [MdlSelectComponent, MdlOptionComponent]; }, imports: function () { return [CommonModule,
        MdlPopoverModule]; }, exports: function () { return [MdlSelectComponent, MdlOptionComponent]; } }); })();

/*
 * Public API Surface of select
 */

/**
 * Generated bundle index. Do not edit.
 */

export { MDL_SELECT_VALUE_ACCESSOR, MdlOptionComponent, MdlSelectComponent, MdlSelectModule, SearchableComponent, ɵ0, ɵ1 };

